import React from 'react';
import { LocaleContext } from '../components/LocalizationProvider';

var useLocalization = function useLocalization() {
  return React.useContext(LocaleContext);
};

export default useLocalization;